import * as Yup from "yup";
import { isValidPhoneInput } from "../libphonenumber/api";

// Define the custom phone validation function
const handlePhoneValidation = (inputNumber: string) => {
  if (inputNumber && inputNumber.length) {
    const valid = isValidPhoneInput(inputNumber);
    return valid;
  }
  return true; // Assume empty input is valid
};

// Extend Yup's StringSchema to add the custom phone method
declare module "yup" {
  interface StringSchema {
    phone(message: string): this;
  }
}

Yup.addMethod<Yup.StringSchema>(
  Yup.string,
  "phone",
  function check(message: string) {
    return this.test("phone", message, function handle(value) {
      const { path, createError } = this;
      return (
        handlePhoneValidation(value || "") || createError({ path, message })
      );
    });
  }
);

export default Yup;
